import {
  Component,
  Input,
  ChangeDetectionStrategy,
  inject,
  DestroyRef,
  ChangeDetectorRef,
  OnInit
} from '@angular/core';
import { Machine } from '@shared/entities/machine';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-icam-machine-alert',
  templateUrl: './icam-machine-alert.component.html',
  styleUrl: './icam-machine-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IcamMachineAlertComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);
  private _themeService = inject(ThemeService);

  isLight = true;

  @Input() machine?: Machine;

  constructor() {
    /* noop */
  }

  ngOnInit() {
    this._themeService.isLight$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap((x) => {
          this.isLight = x;
          this._cdr.markForCheck();
        })
      )
      .subscribe();
  }
}
